import { mergeStyles, useTheme, Text } from "@fluentui/react";
import React, { useMemo } from "react";
import {
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";

interface IProps {
    plan: FAM_IPlan
}

const PlanSummary: React.FunctionComponent<IProps> = ({ plan }) => {
    const theme = useTheme();

    const styleSummary = useMemo(() => {
        const styleSummary: Record<string, React.CSSProperties> = {
            "dl": {
                width: '100%',
                padding: '5px',
            },
            "dt": {
                fontWeight: 680,
                textAlign: 'right',
                width: "120px",
                padding: '5px',
            },
            "dd": {
                padding: '5px',
            }
        }
        return styleSummary;
    }, []);

    const tBodyClass = useMemo(() => {
        return mergeStyles({
            "td": {
            },
            "& > :nth-child(even)": {
                backgroundColor: theme.semanticColors.bodyDivider,
            }
        });
    }, [theme]);

    const headerStyles = useMemo(() => {
        const headerStyles = { root: { fontWeight: '680' } }
        return headerStyles;
    }, []);

    return (
        <table style={styleSummary.dl}>
            <tbody className={tBodyClass}>
                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Name</Text></td>
                    <td style={styleSummary.dd}><Text>{plan.name}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Funding Type</Text></td>
                    <td style={styleSummary.dd}><Text>{plan.fundingType?.name ?? '-'}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>GF/NGF Type</Text></td>
                    <td style={styleSummary.dd}><Text>{plan.grandFathered?.name ?? '-'}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Deactivated</Text></td>
                    <td style={styleSummary.dd}><Text>{plan.deactivated ? 'Yes' : 'No'}</Text></td>
                </tr>
            </tbody>
        </table>
    );
}

export default PlanSummary;